const _temp0 = require("url:./CL V3 mix.mp3");
const _temp1 = require("url:./FF V3 mix.mp3");
const _temp2 = require("url:./FT V3 mix.mp3");
const _temp3 = require("url:./General V3 mix.mp3");
const _temp4 = require("url:./New Look v1.mp3");
const _temp5 = require("url:./Rare plant v2.mp3");
module.exports = {
  "CL V3 mix.mp3": _temp0,
  "FF V3 mix.mp3": _temp1,
  "FT V3 mix.mp3": _temp2,
  "General V3 mix.mp3": _temp3,
  "New Look v1.mp3": _temp4,
  "Rare plant v2.mp3": _temp5
}